<template>
    <div class="e-temporary-password-form">
    
        <div class="c-form">

            <div class="e-temporary-password-form__field">
                <label for="customer_number">Customer Number</label>            
                <input id="customer_number" type="text" v-model="member_number" maxlength="6" />
                <span class="description">6 digit customer number printed on the back of your SBS VISA Credit Card</span>
                <span class="error" v-if="form_errors.member_number">{{ form_errors.member_number }}</span>
            </div>

            <div class="">
                <button
                    class="button button--primary"
                    @click.prevent="generateTemporaryPassword"
                >
                    Send temporary password
                </button>
            </div>
            
            <div class="e-temporary-password-form__error u-content" v-if="password_error">
                <p>An error has occurred. Please try again.</p>
            </div>
            <div class="e-temporary-password-form__success u-content" v-if="password_success">
                <p>Enter the temporary password received on your phone into internet banking.</p>
            </div>
        </div>
    
    </div>
</template>

<script>
    import { mapState, mapActions } from "vuex";
    import { mapFields } from "vuex-map-fields";
    import axios from "axios";

    /**
     * Trigger a temporary password to be sent to the customer's phone number
     * 
     * 1. generate a qik token
     * 2. Using this token and the customer number inputted into the text box: 
     * PUT /api/customerServices/customers/{Customer number}/credentials?requestId={token}
     * 
     */
    
    export default {
        data() {
            return {
                form_errors: {
                    member_number: '',
                },
                password_error: false,
                password_success: false,
            }
        },
        created() {
            // get a qik token
            this.handleGenerateToken();
        },
        computed: {
            ...mapFields([
                "config.baseURL",
                "temporaryPassword.submission.member_number",
            ]),
            ...mapState(['qik_token', 'qik_errors']),
        },
        methods: {
            ...mapActions(['generateQikToken']),

            async handleGenerateToken() {
                await this.generateQikToken();
            },

            async generateTemporaryPassword() {

                // check form errors
                if (!this.isValidMemberNumber(this.member_number)) {
                    this.form_errors.member_number = "Member number must be exactly 6 digits";
                    return;
                }

                let self = this;
                const baseURL = window.location.origin + window.location.pathname;
                
                // Trigger the PHP function using Axios to call the PHP endpoint
                try {
                    // format form data for POST request
                    const payload = {
                        customerNumber: self.member_number
                    };
    
                    // Make the API call to the server-side function
                    const response = await axios.post(`${baseURL}/generateTemporaryPassword`, payload);
                    // console.log("RESPONSE:", response);

                    if (response.data.success) {
                        self.password_success = true;
                    } 
                    
                    if (response.data.error) {
                        // console.log("ERROR:", response.data.error);
                        self.password_error = true;
                        self.password_success = false;
                    }
                
                } catch (error) {    
                    // Handle network or server errors
                    if (error.response && error.response.data && error.response.data.error) {
                        self.password_error = true;
                        self.password_success = false;
                    }    
                }
            },

            isValidMemberNumber(value) {
                const numValue = value.trim();
                return /^\d{6}$/.test(numValue);
            },

            buildApplicationLink() {
                let baseURL = 'TEST';
    
                // build URL
                let params = [
                    `customerNumber=${this.member_number}`,
                    `firstNames=${this.firstnames}`,
                    `surname=${this.lastname}`,
                    `dateOfBirth=${this.dob_day}-${this.dob_month}-${this.dob_year}`,
                ];
    
                return `${baseURL}?${params.join('&')}`;
            },
        }
    }
</script>

<style scoped>
    .error {
        color: red;
        font-size: 16px;
        display: block;
        margin-top: 16px;
    }
</style>